<loader-overlay-component [show]="isloading"></loader-overlay-component>
<div class="dmv-search-results inner-home">
    <div class="container">
      <div class="row no-margin">
        <!--heading section starts here-->
        <div class="col-6 col-sm-2 mt-4 ">
          <a >
             <button class="btn btn-primary btn-back top-back-button"
              (click)="goBack()"><i class="fa fa-chevron-left text-left" ></i> Back</button>
          </a>  
        </div>
        
        <div class="col-12 col-sm-8 mt-4">
          <div id="searchResu">Would you like to make a donation?</div>
          <p id="addthereco">&nbsp;</p>
        </div>
  
  
         <div class="col-6 col-sm-2 icon-cart mt-4">
        <dmv-shoping-cart [donation]="dmvStoreService?.registrationsInCart?.donation" [registrationsInCart]="dmvStoreService?.registrationsInCart?.dmvRegistrations" [registrationsManual]="dmvStoreService?.registrationsInCart?.dmvRegistrationsManual" ></dmv-shoping-cart>
        </div>
  
        <!--heading section ends here-->
  
         
        <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
         {{errorMessage}}
        </div>
   
      
           
  
      </div>
     <div class="row width100">
                <div class="col-12 col-sm-12">
                <div class="row">
                  <div class="col-12 col-md-8 col-sm-8 m-auto">
                         <div class="form-group">
                        <div class="select-wrapper-3 m-auto">
                            <select class="form-control" #selectDonation required="required" [value]="dmvStoreService?.registrationsInCart?.donation?.orgCode" (change)="setDonationOption($event)" (click)="selectChange($event)" (keydown)="selectChangeByKey($event)"  (blur)="setDownIcon($event)">
                             <option value="selectDonation"  >Select a donation option</option>
                              <option value="noThanks"  >No Thanks</option>

                                <option  [value]="item.orgCode" *ngFor="let item of donationOrgsData" [selected]="dmvStoreService?.registrationsInCart?.donation?.orgCode===item.orgCode">{{item.name}}</option>
                              
                            </select>
                            <div class="invalid-feedback">Example enter valid renewal option</div>
                        </div><!-- end .select-wrapper -->   
                    </div>
                      <div class="invalid-feedback">Please select the field</div>
                    <div *ngIf="donationOrg">
                                   <form autocomplete="off" class="text-left mb-5" [formGroup]="donationForm">
        
                      <div id="wehelpprot" class="mt-4">
                       {{donationOrg?.description}}
                      </div>
                      <div class="mb-3">
                          <!-- <div id="firstName">Suggested or Minimum Donation <span style="padding-left:30px">${{((donationOrg?.minAmount)?(donationOrg?.minAmount):0) | number : '1.2-2'}}</span></div>
                           -->
                         <div  id="firstName" class="row">
    
    <div class="col-8 col-sm-9">Suggested or Minimum Donation</div> 
     <div class="col-4 col-sm-3">${{((donationOrg?.minAmount)?(donationOrg?.minAmount):0) | number : '1.2-2'}}</div></div> 

                      </div>
                        <div class="mb-3">
                          <div id="firstName">How much would you like to donate?</div>
                          <div class="input-icon">                          
                              <input #amountInput type="number" (change)="setTwoNumberDecimal($event)" formControlName="amount" min="{{donationOrg?.minAmount}}" class="form-control" required="required" [ngClass]="{ 'is-invalid': submitted && f.amount.errors }"/>
                            
                             <div *ngIf="submitted && f.amount.errors" class="invalid-feedback">
                                <div *ngIf="f.amount.errors?.required">Please enter a donation amount.</div>
                                 <div *ngIf="f.amount.errors?.min">The minimum donation amount is ${{donationOrg?.minAmount | number : '1.2-2'}}</div>
                                 <div *ngIf="f.amount.errors?.max">Amount must not be more than $1,000</div>
                                 <div *ngIf="!f.amount.errors?.min && !f.amount.errors?.max && f.amount.errors?.pattern">Too many digits after the decimal point; 2 max</div>
                                 
                             </div> 

                          </div>
                            
                      </div>
                                   </form>
                      </div>
                  </div>   
                     
                </div>
            </div>
               
        </div>
  <div class="m-auto text-center" >
                  <a >
                        <button class="btn btn-primary btn-back" (click)="goBack()"><i class="fa fa-chevron-left text-left"></i> Back</button>
                    </a>  
                      <a>
          <button class="btn btn-primary  btn-continue m-auto " (click)="continue()" >Continue
            <i class="fa fa-chevron-right text-right"></i>
          </button>
        </a>
      </div>
  
 </div>
  </div>

 